// queryString을 Object로 파싱해주는 함수
export const parseQueryString = (queryString) => {
  const keyValuePairs = queryString
    .substring(1)
    .split('&')
    .map((pair) => pair.split('='))
    .reduce((acc, [key, value]) => {
      acc[key] = value
      return acc
    }, {})

  return keyValuePairs
}

// 선택한 쿼리스트링만 업데이트해주는 함수
export const updateQueryParam = (url, paramName, paramValue) => {
  const searchParams = new URLSearchParams(url)

  if (searchParams.has(paramName)) {
    url = url.replace(
      `${paramName}=${searchParams.get(paramName)}`,
      `${paramName}=${paramValue}`,
    )
  }

  return url
}

export const stringify = (query) => {
  return Object.entries(query)
    .map((e) => e.join('='))
    .join('&')
}

// URL에 존재하는 queryString들을 Object로 변환해주는 함수
export const queryStringToObject = (url) => {
  const queryString = url.split('?')[1]
  const params = new URLSearchParams(queryString)
  const obj = {}

  params.forEach((value, key) => {
    obj[key] = value
  })

  return obj
}

// Object를 queryString으로 변환해주는 함수
export const objectToQueryString = (obj) => {
  const params = new URLSearchParams()

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      params.append(key, obj[key])
    }
  }
  return params.toString()
}

// 변경된 quryString을 적용된 url을 반환해주는 함수
export const updateRouteUrl = (originalUrl, updatedValues) => {
  const baseUrl = originalUrl.split('?')[0]
  const originalQueryObject = queryStringToObject(originalUrl)
  const queryOrder = ['mainCode', 'subCode']

  const mergedQueryObject = {}
  queryOrder.forEach((queryName) => {
    if (updatedValues.hasOwnProperty(queryName)) {
      mergedQueryObject[queryName] = updatedValues[queryName]
      delete updatedValues[queryName]
    } else if (originalQueryObject.hasOwnProperty(queryName)) {
      mergedQueryObject[queryName] = originalQueryObject[queryName]
    }
  })
  Object.assign(mergedQueryObject, updatedValues)

  const newQueryString = objectToQueryString(mergedQueryObject)
  const newUrl = `${baseUrl}?${newQueryString}`

  return newUrl
}

// URL의 쿼리 문자열을 업데이트하는 함수
export const updateQueryString = (baseURL, query) => {
  const searchParams = new URLSearchParams()
  for (const key in query) {
    if (query[key] !== undefined) {
      searchParams.set(key, query[key])
    }
  }
  return `${baseURL}?${searchParams.toString()}`
}

// 라우터 쿼리를 적용하는 함수
export const applyRouterQuery = (currentQuery, routerQuery) => {
  const updatedQuery = { ...currentQuery }
  for (const key in routerQuery) {
    if (routerQuery[key] !== undefined) {
      updatedQuery[key] = routerQuery[key]
    }
  }
  return updatedQuery
}
